import { downloadFullInspectionDto } from '../../../types/inspection.dto';

export const DOWNLOAD_FULL_INSPECTION = 'DOWNLOAD_FULL_INSPECTION';
export const DOWNLOAD_FULL_INSPECTION_SUCCESS = 'DOWNLOAD_FULL_INSPECTION_SUCCESS';
export const DOWNLOAD_FULL_INSPECTION_ERROR = 'DOWNLOAD_FULL_INSPECTION_ERROR';
export const RESET_DOWNLOAD_FULL_INSPECTION = 'RESET_DOWNLOAD_FULL_INSPECTION';

export interface DownloadFullInspection {
    type: typeof DOWNLOAD_FULL_INSPECTION,
    payload: downloadFullInspectionDto
}

export interface DownloadFullInspectionSuccess {
    type: typeof DOWNLOAD_FULL_INSPECTION_SUCCESS,
}

export interface DownloadFullInspectionError {
    type: typeof DOWNLOAD_FULL_INSPECTION_ERROR,
    payload: string | boolean,
}

export interface ResetDownloadFullInspection {
    type: typeof RESET_DOWNLOAD_FULL_INSPECTION,
    payload: null,
}

export interface State {
    states: {
        loading: boolean,
        success: boolean,
        error: boolean | string
    },
}

export const initialState: State = {
    states: {
        loading: false,
        success: false,
        error: false,
    }
}

export type Actions = DownloadFullInspection | DownloadFullInspectionSuccess | DownloadFullInspectionError | ResetDownloadFullInspection;